import { useMutation, useQuery } from "urql";
import { graphql } from "../../../../__generated__/gql";
import Modal from "../../../../ui/Modal/Modal";
import { useCallback } from "react";
import PublishModal from "../../../../components/PublishModal/PublishModal";
import { ArticleStatus } from "../../../../__generated__/gql/graphql";
import { useToast } from "../../../../ui/Toast/ToastContext";

const PublishPatternModalQuery = graphql(/* GraphQL */ `
  query publishPatternModal($id: String!) {
    canPublish {
      canPublish
    }
    articleCounts(input: { filters: [{ patternIds: [$id] }] }) {
      published
      total
    }
  }
`);

const PublishPatternArticlesMutation = graphql(/* GraphQL */ `
  mutation publishPatternArticles(
    $id: String!
    $articleFilters: [ArticleFilter!]
  ) {
    publishPatterns(
      input: { filters: [{ ids: [$id] }], articleFilters: $articleFilters }
    ) {
      count
    }
  }
`);

function PublishPatternModal({
  isOpen,
  onClose,
  id,
}: {
  isOpen: boolean;
  onClose: () => void;
  id: string;
}) {
  const { showToast } = useToast();
  const [publishPatternModalResponse] = useQuery({
    query: PublishPatternModalQuery,
    pause: !isOpen,
    variables: {
      id,
    },
  });
  const [{ fetching }, publishPatternArticles] = useMutation(
    PublishPatternArticlesMutation,
  );

  const onSubmit = useCallback(
    async (republish: boolean) => {
      await publishPatternArticles({
        id,
        articleFilters: !republish
          ? [{ status: [{ notIncludes: [ArticleStatus.Published] }] }]
          : [],
      });
      showToast({ title: "Pattern published" });
      onClose();
    },
    [publishPatternArticles, id, showToast, onClose],
  );

  const canPublish = !!publishPatternModalResponse.data?.canPublish.canPublish;
  const articleCounts = publishPatternModalResponse.data?.articleCounts;

  const title = !canPublish
    ? `Connect your website to publish`
    : `Confirm publishing of ${articleCounts?.total} ${
        articleCounts?.total === 1 ? "article" : "articles"
      } `;
  const subtitle =
    articleCounts?.published === articleCounts?.total
      ? "This will replace articles on your site"
      : undefined;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      loading={
        publishPatternModalResponse.fetching ||
        !publishPatternModalResponse.data
      }
      title={title}
      subtitle={subtitle}
    >
      <PublishModal
        onClose={onClose}
        canPublish={canPublish}
        onSubmit={onSubmit}
        fetching={fetching || !isOpen}
        articleCounts={publishPatternModalResponse.data?.articleCounts}
      />
    </Modal>
  );
}

export default PublishPatternModal;
